import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import Tab from '@material-ui/core/Tab'
import styled from 'styled-components'
import { Box } from 'reflexbox'
import AccountDetails from '../AccountDetails/AccountDetailsContainer'
import BrandingLinks from '../BrandingLinks/BrandingLinks'
import BranchesList from '../BranchesList/BranchesListContainer'
import FeatureFlags from '../FeatureFlags/FeatureFlags'
import OrganisationPlan from '../OrganisationPlan/OrganisationPlan'
import DocumentsList from '../DocumentsList/DocumentsList'
import { organisationPlanLabel } from '../Shared/organisationPlans'
import { HeaderContainer, TabButtons, BounceAnimatedContainer, MenuItems } from '../../healtheraComponents'
import PlusWebsiteEditorContainer from '../PlusWebsiteEditor/PlusWebsiteEditorContainer'

const PHARMACEUTICAL_TABS = ['account', 'plan', 'branding', 'website', 'branches', 'feature_flags', 'documents']
const NON_PHARMACEUTICAL_TABS = ['website']

class PharmacyDetails extends Component {

  getTabFromUrl(location = this.props.location) {
    const params = new URLSearchParams(location.search);
    return params.get('tab');
  }

  state = {
    value: this.getTabFromUrl() || 'account',
  }

  updateUrlTab(tab, usePush = true) {
    const { history, location } = this.props;
    const params = new URLSearchParams(location.search);
    params.set('tab', tab);
    if (usePush) {
      history.push({ search: params.toString() });
    } else {
      history.replace({ search: params.toString() });
    }
  }

  async componentDidMount() {
    const orgID = this.props.match.params.organisationID;
    await this.props.getOrganisation(orgID)
    const { organisation } = this.props
    const { type } = organisation || {};

    const isPharmaceutical = typeof type === 'undefined' || type === null;
    const availableTabs = isPharmaceutical ? PHARMACEUTICAL_TABS : NON_PHARMACEUTICAL_TABS;
    const urlTab = this.getTabFromUrl();
    const defaultTab = isPharmaceutical ? 'account' : 'website';
    const initialTab = availableTabs.includes(urlTab) ? urlTab : defaultTab;

    this.setState({ value: initialTab });
    if (urlTab !== initialTab) {
      this.updateUrlTab(initialTab, false);
    }

    this.unlisten = this.props.history.listen((location) => {
      const tab = this.getTabFromUrl(location);
      if (tab && tab !== this.state.value) {
        this.setState({ value: tab });
        this.props.changeTab(tab);
      }
    });

    if (!organisation)
      this.setState({ message: ` This organisation doesn't exist` })
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  handleChange = (event, value) => {
    this.props.changeTab(value)
    this.setState({ value })
    this.updateUrlTab(value)
  }

  render() {
    const { value } = this.state
    const { organisation = null, mainTabValue } = this.props
    const { type } = organisation || {};

    const isPharmaceutical = typeof type === 'undefined' || type === null;

    return (
      <Fragment>
        {!organisation && <p>{this.state.message}</p>}
        {organisation && <BounceAnimatedContainer>
          <HeaderContainer p={2} align='center'>
            <PlanBadges p={2}>
              {mainTabValue !== 2 && organisation && <PlanTag>{organisationPlanLabel(organisation.plan)}</PlanTag>}
            </PlanBadges>
            <Tabs px={2}>
              <TabButtons color={`#2f9d6d`} value={value} onChange={this.handleChange.bind(value)}>
                {isPharmaceutical && <Tab disableRipple value="account" label='Account Details' />}
                {isPharmaceutical && <Tab disableRipple value="plan" label='Plan' />}
                {isPharmaceutical && <Tab disableRipple value="branding" label='Branding Assets' />}
                <Tab disableRipple value="website" label='Plus Website' />
                {isPharmaceutical && <Tab disableRipple value="branches" label='Branches' />}
                {isPharmaceutical && <Tab disableRipple value="feature_flags" label='Feature Flags' />}
                {isPharmaceutical && <Tab disableRipple value="documents" label='Documents' />}
              </TabButtons>
            </Tabs>
          </HeaderContainer>
          {value === "account" && <Fragment>
            <BounceAnimatedContainer>
              <AccountDetails organisation={organisation} organisationID={this.props.match.params.organisationID} />
            </BounceAnimatedContainer>
          </Fragment>}
        </BounceAnimatedContainer>}
        {value === "branding" && <Fragment>
          {organisation && <BounceAnimatedContainer>
            <BrandingLinks organisation={organisation} orgID={this.props.match.params.organisationID} />
          </BounceAnimatedContainer>}
        </Fragment>}
        {value === "website" && <Fragment>
          {organisation && <BounceAnimatedContainer>
            <PlusWebsiteEditorContainer organisation={organisation} />
          </BounceAnimatedContainer>}
        </Fragment>}
        {value === "branches" && <Fragment>
          {organisation && <BounceAnimatedContainer>
            <BranchesList organisation={organisation} />
          </BounceAnimatedContainer>}
        </Fragment>}
        {value === "plan" && isPharmaceutical && <Fragment>
          <BounceAnimatedContainer>
            <OrganisationPlan />
          </BounceAnimatedContainer>
        </Fragment>}
        {value === "feature_flags" && <Fragment>
          <BounceAnimatedContainer>
            <FeatureFlags {...this.props} />
          </BounceAnimatedContainer>
        </Fragment>}
        {value === "documents" && <Fragment>
          <BounceAnimatedContainer>
            <DocumentsList {...this.props} />
          </BounceAnimatedContainer>
        </Fragment>}
      </Fragment>
    )
  }
}

export default withRouter(PharmacyDetails)

const PlanTag = styled.span`
  color: #2f9d6d;
  font-size: 20px;
  font-weight: 600;
`

const PlanBadges = styled(Box)`
  && {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 12px;
    white-space: nowrap;
  }
`

const Tabs = styled(MenuItems)`
  && {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    justify-content: flex-end;
  }
`
